import React, { Component } from "react";
import { connect } from "react-redux";
import { Menu, Segment, Tab, Table } from "semantic-ui-react";
import AppMenu from "../../components/pages/AppMenu";
import { expireSession } from "../../actions/auth";
import TodayResultsAndReports from "./TodayResultsAndReports";
import Last7DaysResultsAndReports from "./Last7DaysResultsAndReports";
import OlderHistoryResultsAndReports from "./OlderHistoryResultsAndReports";
import PickUserForm from "../forms/PickUserForm";
import { getMySearchesBreadcrumb } from "../common/Breadcrumb";
import settings from "../../settings";

class MySearches extends Component {
  state = {
    pickedUser: "",
    activeIndex: 0,
  };

  submit = (data) => {
    this.state.pickedUser = data.pickuser;
    this.setState({ pickedUser: data.pickuser });
  };

  handleTabChange = (e, { activeIndex }) => {
    this.setState({ activeIndex });
  };

  render() {
    const tabs = [];
    const { acctTheme } = this.props.userAccount;
    const { activeIndex } = this.state;
    tabs.push({
      menuItem:
        acctTheme === 0 ? (
          <Menu.Item
            key={`Tab_Today`}
            style={{
              fontSize: "12px",
              borderRadius: "10px 10px 0 0 !important",
            }}
            className={
              activeIndex === 0
                ? "classicTab selected_background"
                : "classicTab form_tab_unselected"
            }
          >
            Today
          </Menu.Item>
        ) : (
          `Today`
        ),
      render: () => (
        <TodayResultsAndReports
          pickedUser={this.state.pickedUser}
          {...this.props}
        />
      ),
    });

    tabs.push({
      menuItem:
        acctTheme === 0 ? (
          <Menu.Item
            key={`Tab_Last7Days`}
            style={{
              fontSize: "12px",
              borderRadius: "10px 10px 0 0 !important",
            }}
            className={
              activeIndex === 1
                ? "classicTab selected_background"
                : "classicTab form_tab_unselected"
            }
          >
            Last 7 Days
          </Menu.Item>
        ) : (
          `Last 7 Days`
        ),
      render: () => (
        <Last7DaysResultsAndReports
          pickedUser={this.state.pickedUser}
          {...this.props}
        />
      ),
    });

    tabs.push({
      menuItem:
        acctTheme === 0 ? (
          <Menu.Item
            key={`Tab_OlderHistory`}
            style={{
              fontSize: "12px",
              borderRadius: "10px 10px 0 0 !important",
            }}
            className={
              activeIndex === 2
                ? "classicTab selected_background"
                : "classicTab form_tab_unselected"
            }
          >
            Older History
          </Menu.Item>
        ) : (
          `Older History`
        ),
      render: () => (
        <OlderHistoryResultsAndReports
          pickedUser={this.state.pickedUser}
          {...this.props}
        />
      ),
    });
    return (
      <div className="container-fluid">
        <div className="padding-top-20" />
        <AppMenu
          uiData={this.props.uiData}
          userAccount={this.props.userAccount}
          history={this.props.history}
        />
        <div>
          <Segment>
            {getMySearchesBreadcrumb({
              currentPage: settings.myAccountMenuItem.subMenuItems[0].MenuTitle,
              history: this.props.history,
            })}
            <br />
            <span className={"picked-user"}>{`UserName: ${
              this.state.pickedUser !== ""
                ? this.state.pickedUser
                : this.props.user.userid
            }`}</span>{" "}
            {this.props.userAccount.acctPickUser === "1" && (
              <Table>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell colSpan={2}>
                      <PickUserForm submit={this.submit} />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            )}
            <Tab
              panes={tabs}
              className="margin-top-10 medium-font"
              activeIndex={activeIndex}
              onTabChange={this.handleTabChange}
            />
          </Segment>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, { expireSession })(MySearches);



// WEBPACK FOOTER //
// ./src/components/myaccount/MySearches.js